const hasThreeLetters = (value: string) => /(.*[A-Za-z]){3}/i.test(value);

export default hasThreeLetters;
